import { createStore } from '../../lib/create-store';

import { getActions, getInitialState, getReducer } from '.';

const ACTION_PREFIX = 'LATEST_NEWS_INFINITE';

const initialState = getInitialState();
const reducer = getReducer(ACTION_PREFIX);

export const latestNewsInfiniteStore = createStore({
  initialState,
  reducer,
  name: 'latestNewsInfiniteStore',
});

export const latestNewsInfiniteActions = getActions(ACTION_PREFIX);
